<template>
  <basicContainer>
    <div style="text-align: center; display:inline-block;">
      <h4>智隆信息绩效考核结构表</h4>
    </div>
    <el-button type="primary" size="mini" style="float: right;margin:18px;" @click="sync"
      v-if="loginInfo">同步</el-button>
    <el-input placeholder="输入关键字进行过滤" v-model="filterText">
    </el-input>
    <div class="mytree">
      <el-tree class="filter-tree" ref="tree" :indent='0' empty-text="暂无数据" node-key="id" default-expand-all
        @node-click="handleNodeClick" :data="data" :props="defaultProps" :filter-node-method="filterNode"
        :allow-drop="allowDrop" :allow-drag="allowDrag" :expand-on-click-node="false">
        <span class="custom-tree-node" slot-scope="{ node, data }" v-if="loginInfo">
          <span>{{ node.label }}</span>
          <span>
            <!--             <el-button type="text" size="mini" icon="el-icon-plus" @click="() => append(data)">添加</el-button>-->
            <el-button v-if="data.id !== '18930010369'" type="text" size="mini" icon="el-icon-edit"
              @click="() => treeEdit(data)">编辑</el-button>
            <el-button v-if="data.id !== '18930010369'" type="text" size="mini" icon="el-icon-delete"
              @click="() => remove(node, data)">删除</el-button>
          </span>
        </span>
        <span class="default-tree-node" slot-scope="{ node, data }" v-else>
          <span>{{ node.label }}</span>
        </span>
      </el-tree>
    </div>
    <el-dialog title="编辑员工" width="25%" :visible.sync="editdialogVisible">
      <el-form ref="form" label-position="right" label-width="80px">
        <el-form-item label="上级领导">
          <el-select v-model="selectmodelvalue" value="selectvalue" filterable placeholder="请选择" style="width: 100%">
            <el-option v-for="item in options" :key="item.id" :label="item.name + item.id" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="员工">
          <el-input v-model="yginfo" readonly></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editdialogVisible = false">取消</el-button>
        <el-button @click="editmanageSave" type="primary">确定</el-button>
      </span>
    </el-dialog>
  </basicContainer>
</template>

<script>
export default {
  data() {
    return {
      filterText: '',
      editdialogVisible: false,
      dialogVisible: false,
      data: [],
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      leader: {
        id: '',
        label: ''
      },
      inputid: '',
      addData: [],
      yginfo: [],
      options: [],
      selectmodelvalue: {},
      ygnodeinfo: {},
      loginInfo: false
    }
  },
  created() {
    this.getloginInfo()
    this.loadData()
    this.querylistData()
  },
  methods: {
    getloginInfo() {
      this.$http.get('/t-pa-account/getLoginInfo').then(response => {
        console.log(response.data)
        response.data[0].roleList.forEach(item => {
          // console.log(item.name)
          if (['部门主管', '人事经理'].includes(item.name)) {
            this.loginInfo = true
          }
        })
        if (response.data[0].loginName == 'wipadmin') {
          this.loginInfo = true
        }
      })
    },
    loadData() {
      this.$http.get('/t-pa-account/queryTreeList').then(response => {
        this.data = [response.data]
      }).catch(error => {
        this.$message.error(error.msg || error.message)
      })
    },
    querylistData() {
      this.$http.get('/t-pa-account/queryList').then(response => {
        this.options = response.data
      }).catch(error => {
        this.$message.error(error.msg || error.message)
      })
    },
    // listData() {
    //   this.$http.get('/t-pa-account/getByLoginName', {
    //     params: {
    //       loginName: this.inputid
    //     }
    //   }).then(response => {
    //     this.addtreeNode.id = response.data.loginName
    //     this.addtreeNode.label = response.data.name
    //   }).catch(error => {
    //     this.$message.error(error.msg || error.message)
    //   })
    // },
    filterNode(value, data) {
      if (!value) return true
      return data.label.indexOf(value) !== -1
    },
    treeEdit(node, data) {
      this.yginfo = node.label + node.id
      this.ygnodeinfo = node
      this.selectmodelvalue = node.pid
      this.editdialogVisible = true
    },
    remove(node, data) {
      this.list = [data]
      this.$confirm('确认要删除此员工, 是否继续?', '提示', { cancelButtonText: '取消', confirmButtonText: '确定', type: 'warning' }).then(() => {
        this.$http.post('/t-pa-account/deletePaAccount', this.list, {
        }).then(response => {
          const parent = node.parent
          const children = parent.data.children || parent.data
          const index = children.findIndex(d => d.id === data.id)
          children.splice(index, 1)
          this.$message.success(response.data)
          this.loadData()
        }).catch(error => {
          this.$message.error(error.msg || error.message)
        })
      }).catch(() => {
        this.$message({ type: 'info', message: '已终止本次操作' })
      })
    },
    sync() {
      this.$http.get('/t-pa-account/synsAccount').then(response => {
        this.$message.success(response.data)
        this.loadData()
      })
    },
    editmanageSave() {
      console.log(this.ygnodeinfo)
      console.log(this.selectmodelvalue)
      let editData = [{
        id: this.ygnodeinfo.id,
        loginName: this.ygnodeinfo.id,
        name: this.ygnodeinfo.label,
        pid: this.selectmodelvalue
      }]
      this.$http.post('/t-pa-account/updatePaAccount', editData).then(response => {
        this.loadData()
        this.$message('修改成功')
      })
      this.editdialogVisible = false
    }
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val)
    }
  }
}
</script>

<style lang="scss" scoped>
.mytree :deep {
  .el-tree > .el-tree-node:after {
    border-top: none;
  }
  .el-tree-node {
    position: relative;
    padding-left: 26px;
  }
  //节点有间隙，隐藏掉展开按钮就好了,如果觉得空隙没事可以删掉
  .el-tree-node__expand-icon.is-leaf {
    display: none;
  }
  .el-tree-node__children {
    padding-left: 16px;
  }

  .el-tree-node :last-child:before {
    height: 38px;
  }

  .el-tree > .el-tree-node:before {
    border-left: none;
  }

  .el-tree > .el-tree-node:after {
    border-top: none;
  }

  .el-tree-node:before {
    content: "";
    left: -4px;
    position: absolute;
    right: auto;
    border-width: 1px;
  }

  .el-tree-node:after {
    content: "";
    left: -4px;
    position: absolute;
    right: auto;
    border-width: 1px;
  }

  .el-tree-node:before {
    border-left: 1px dashed #999999;
    bottom: 0px;
    height: 100%;
    top: -26px;
    width: 1px;
  }

  .el-tree-node:after {
    border-top: 1px dashed #999999;
    height: 20px;
    top: 12px;
    width: 24px;
  }
}
:deep(.filter-tree) {
  margin-top: 20px;
}
.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}
.default-tree-node {
  font-size: 14px;
}
</style>
